import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { formatPrice } from "@/store/storeCart";
import { ImageIcon } from "lucide-react";

export type StoreProductCardData = {
  id: string;
  slug: string;
  title: string;
  base_price_cents: number;
  currency: string;
  images: string[] | null;
  vendor: { slug: string; display_name: string } | null;
  /** Optional: pass the category slug so books route to /store/book/:slug */
  categorySlug?: string;
};

const StoreProductCard = ({ product }: { product: StoreProductCardData }) => {
  const img = product.images?.[0];
  const href =
    product.categorySlug === "books"
      ? `/store/book/${product.slug}`
      : `/store/product/${product.slug}`;
  return (
    <Link to={href} className="group">
      <Card className="overflow-hidden transition-all hover:shadow-lg relative">
        <div className="absolute top-2 right-2 z-10">
          <Badge className="bg-amber-500/90 text-white text-[10px] uppercase tracking-wider hover:bg-amber-500">
            Demo
          </Badge>
        </div>
        <div className="aspect-square bg-muted/50 flex items-center justify-center overflow-hidden">
          {img ? (
            <img
              src={img}
              alt={product.title}
              loading="lazy"
              className="h-full w-full object-cover transition-transform group-hover:scale-105"
            />
          ) : (
            <ImageIcon className="h-12 w-12 text-muted-foreground/40" />
          )}
        </div>
        <div className="p-4 space-y-1">
          {product.vendor && (
            <p className="text-xs text-muted-foreground truncate">
              {product.vendor.display_name}
            </p>
          )}
          <h3 className="font-medium leading-tight line-clamp-2">{product.title}</h3>
          <p className="text-sm font-semibold pt-1">
            {formatPrice(product.base_price_cents, product.currency)}
          </p>
        </div>
      </Card>
    </Link>
  );
};

export default StoreProductCard;
